// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select {\n  height: 30px;\n}\n* {\n  text-align: center;\n}\n.quiet,\n.quiet a {\n  color: #5e6c84;\n}\n.hint {\n  font-size: 13px;\n  margin-top: 4px;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
